import React, {useState} from "react";
import {Button, Table} from "antd";
import {useDispatch, useSelector} from "react-redux";
import {CATEGORY_REDUCER} from "../../reducers/category.reducer";
import {Colors} from "../../ui-util/colors";

const CategoryListComponent = () => {
    const dispatch = useDispatch();
    const {categoryList, selectedRowKeys, loading} = useSelector(state => state.categoryReducer)

    const [columns] = useState([
        {
            key: 'name', dataIndex: 'name', title: 'Name'
        }, {
            key: 'slug', dataIndex: 'slug', title: 'Slug'
        }, {
            key: 'action', title: 'Action',
            render: (record) => (
                <Button onClick={() => {
                    dispatch({type: CATEGORY_REDUCER, payload: {categoryDetail: record}})
                    window.location.href = `/admin/category/update/${record.id}`
                }} style={{
                    borderWidth: 0,
                    color: Colors.armyGray,
                    backgroundColor: 'transparent'
                }}>Edit</Button>
            )
        }
    ])

    const rowSelection = {
        selectedRowKeys,
        onChange: (selectedRowKeys) => {
            dispatch({type: CATEGORY_REDUCER, payload: {selectedRowKeys}});
        }
    }

    return (
        <Table
            columns={columns}
            dataSource={categoryList}
            rowKey={'id'}
            rowSelection={rowSelection}
            loading={loading}
        />
    )
}

export default CategoryListComponent
